export default __webpack_public_path__ + "static/on-shelf-availability-d839210d0d93151e382a694879579b8f.jpg";